/** Must match CONTACT_EMAIL_VARIABLE in server/services/email.js */
export const CONTACT_EMAIL_VARIABLE = 'contact_email'

const CONTACT_EMAIL_DEFAULT = {
  variable: CONTACT_EMAIL_VARIABLE,
  type: 'String',
  value: '',
  complextype: '',
}

const CONTACT_EMAIL_PATTERN = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i

export function isValidContactEmail(value: unknown): boolean {
  const trimmed = String(value ?? '').trim()
  return trimmed.length > 0 && CONTACT_EMAIL_PATTERN.test(trimmed)
}

/** Ensure every site exposes a contact_email entry in settings_variables. */
export function ensureContactEmailVariable(settingsVariables: any[] = []): any[] {
  const list = Array.isArray(settingsVariables) ? [...settingsVariables] : []
  if (list.some((entry) => entry.variable === CONTACT_EMAIL_VARIABLE)) {
    return list
  }
  return [CONTACT_EMAIL_DEFAULT, ...list]
}
